// Keys are translated from enUS
export * from './arSD';
export * from './beBY';
export * from './bgBG';
export * from './csCZ';
export * from './daDK';
export * from './deDE';
export * from './elGR';
export * from './enUS';
export * from './esES';
export * from './faIR';
export * from './fiFI';
export * from './frFR';
export * from './heIL';
export * from './huHU';
export * from './itIT';
export * from './jaJP';
export * from './koKR';
export * from './nbNO';
export * from './nlNL';
export * from './plPL';
export * from './ptBR';
export * from './roRO';
export * from './ruRU';
export * from './skSK';
export * from './svSE';
export * from './trTR';
export * from './ukUA';
export * from './urPK';
export * from './viVN';
export * from './zhCN';
export * from './zhTW';


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/locales/index.js
// module id = 2433
// module chunks = 25